import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { submitConsultationRequest } from '../services/contactService';

const NewsletterSection = () => {
  const { t } = useLanguage();
  const n = t.newsletter;

  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState({
    type: 'idle',
    message: n.defaultMeta,
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setFeedback({ type: 'idle', message: n.sendingButton });

    try {
      const response = await submitConsultationRequest(email.trim());

      setEmail('');
      setFeedback({
        type: 'success',
        message: response.message ?? 'Thanks - your request has been sent successfully.',
      });
    } catch (error) {
      setFeedback({
        type: 'error',
        message: error.message ?? 'Unable to send your request right now. Please try again shortly.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="news-letter-section" className="newsletter-section">
      <div className="newsletter-overlay" aria-hidden="true" />
      <div className="newsletter-content">
        <h2>{n.heading}</h2>
        <p>{n.body2}</p>
        <form className="newsletter-form" onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder={n.placeholder}
            aria-label={n.emailLabel}
            required
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? n.sendingButton : n.sendButton}
          </button>
        </form>
        <p
          className={`newsletter-meta${feedback.type !== 'idle' ? ` is-${feedback.type}` : ''}`}
          aria-live="polite"
        >
          {feedback.message}
        </p>
      </div>
    </section>
  );
};

export default NewsletterSection;
